// extracted by mini-css-extract-plugin
export default {"form":"UrmqQ dialog-content","subfields":"RSsN_","field":"UsTlE","inlineLabel":"B4Tel","label":"yMTOz","select":"B3MZ4"};